import getConfig from 'next/config';

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import API_PATH from '../actions/actionsFactory/apiPath';
import { gwGet } from '../actions/actionsFactory/gwRequest';

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const { GET_GEETEST_CODE_API_PATH } = API_PATH;

class Geetest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ins: null,
    };
  }

  async componentDidMount() {
    const result = await gwGet(GET_GEETEST_CODE_API_PATH, null, null, false);
    if (result.success) {
      this._init(result.data);
    }
  }

  componentWillUnmount() {
    this._destroy();
  }

  _init = gtCode => {
    if (window.initGeetest) {
      return this._ready(gtCode);
    }

    const ds = document.createElement('script');
    ds.type = 'text/javascript';
    ds.async = true;
    ds.charset = 'utf-8';
    if (ds.readyState) {
      ds.onreadystatechange = () => {
        if (ds.readyState === 'loaded' || ds.readyState === 'complete') {
          ds.onreadystatechange = null;
          this._ready(gtCode);
        }
      };
    } else {
      const that = this;
      ds.onload = () => {
        ds.onload = null;
        that._ready(gtCode);
      };
    }
    ds.src = `${assetPrefix}/static/gt.js?_t=${new Date().getTime()}`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ds, s);
    return null;
  };

  _ready = gtCode => {
    const { gt, challenge, apiUrl } = gtCode;
    const {
      https, product, lang, sandbox, width, success,
    } = this.props;
    const { ins } = this.state;

    if (!window.initGeetest) {
      return;
    }

    if (ins) {
      this._load(ins);
    }
    let params = {
      gt,
      challenge,
      https,
      product,
      lang,
      sandbox,
      width,
      offline: challenge.length === 34 ? true : !success,
      new_captcha: true,
    };
    if (apiUrl) {
      params = { ...params, api_server: apiUrl };
    }
    window.initGeetest(
      params,
      geetest => {
        this._load(geetest);

        this.setState({
          ins: geetest,
        });
      }
    );
  };

  _load = ins => {
    const {
      onReady, onSuccess, onError, onClose,
    } = this.props;
    /* eslint-disable-next-line */
    ins.appendTo(ReactDOM.findDOMNode(this));
    ins.onReady(() => onReady(ins));
    ins.onSuccess(() => onSuccess(ins.getValidate()));
    ins.onError(onError);
    ins.onClose(() => {
      ins.reset();
      onClose && onClose();
    });
  };

  _destroy = () => {
    this.setState({
      ins: null,
    });
  };

  render() {
    const { challenge } = this.state;

    return <div className="i-geetest" key={challenge} />;
  }
}

Geetest.propTypes = {
  success: PropTypes.number.isRequired,
  https: PropTypes.bool,
  product: PropTypes.string,
  lang: PropTypes.string,
  sandbox: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onReady: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onClose: PropTypes.func,
};

Geetest.defaultProps = {
  https: false,
  product: 'float',
  lang: 'en',
  sandbox: false,
  onReady() { },
  onSuccess() { },
  onError() { },
  onClose() { },
};

export default Geetest;
